// extracted by mini-css-extract-plugin
module.exports = {"page":"StartPage_page__2AWVY","welcomeSegment":"StartPage_welcomeSegment__2KmcT","companyLogoSegment":"StartPage_companyLogoSegment__V2nPy"};